var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "#99ADBA",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.26558 1.05234L9.88986 5.67232C10.0367 5.82024 10.0367 6.05942 9.88986 6.20734L9.27121 6.83047C9.12436 6.97838 8.88689 6.97838 8.74004 6.83047L5 3.10112L1.25996 6.83047C1.11311 6.97838 0.87564 6.97838 0.72879 6.83047L0.11014 6.20733C-0.0367002 6.05942 -0.0367002 5.82024 0.11014 5.67232L4.73442 1.05234C4.88127 0.904422 5.11873 0.904422 5.26558 1.05234Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/ChevronUp.257cbfff2fd879896fa259cc5866808b.svg";
export { ForwardRef as ReactComponent };